import { Component, inject, signal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/auth.service';
import { filter } from 'rxjs/operators';
// Importamos el package.json para poder extraer la versión
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-home',
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  public authService = inject(AuthService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute)

    // Usamos una señal para que el título se actualice automáticamente
  public pageTitle = signal('Cargando...');
  private titleUrl = '';
  public appVersion = packageJson.version;

  ngOnInit() {
    /*
    const currentPath = window.location.pathname;
    console.log('Current path:', currentPath);
    const urlItems = currentPath.split("/");
    const section = urlItems[urlItems.length-1]; // currentPath.split("/")[1];
    if( section === "login") {
      this.title_path = ""
    } else if(section === "collection") {
      this.title_path = "Documentos - " + currentPath.split("/")[2]
    } else if (section === "search") {
      this.title_path = "Búsqueda - " + currentPath.split("/")[2]
    } else { // if(section === "" || section == "collections") {
      this.title_path = "Colecciones"
    }
    */
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const paramMsg = this.activatedRoute.snapshot.queryParamMap.get('msg');      
      if (paramMsg) this.pageTitle.set(paramMsg);
      else {
        const currentPath = event.urlAfterRedirects.split('?')[0];
        console.log('Current path:', currentPath);
        const urlItems = currentPath.split("/");
        const section = urlItems[urlItems.length-1]; // currentPath.split("/")[1];
        if (currentPath.startsWith("/login")) {
          this.pageTitle.set("")
          this.titleUrl = ''
        } else if(currentPath.startsWith("/collections")) {
          this.pageTitle.set("Colecciones")
          this.titleUrl = currentPath
        } else if(currentPath.startsWith("/collection")) {
          this.pageTitle.set("Documentos - " + section)
          this.titleUrl = currentPath
        } else if (currentPath.startsWith("/search")) {
          this.pageTitle.set("Búsqueda - " + section)
        } else if (currentPath.startsWith("/topics")) {
          this.pageTitle.set("Temas identificados")
        } else {
          this.pageTitle.set("Página no encontrada")
          this.titleUrl = ''
        }
      }
    });
  }

  onLogout() {
    // 1. Borramos el token
    this.authService.logout();
    
    // 2. Redirigimos al Login
    this.router.navigate(['/login']);
  }

  onReload() {
    console.log('titleUrl:', this.titleUrl)
    this.router.navigate([this.titleUrl]);
  }

}
